import { changeModalState } from "reducers/modal/modal-actions"
import { useAppDispatch, useAppSelector } from "reducers/store"

export function useModal<T>() {
  const appDispatch = useAppDispatch()

  const { state, type, metadata } = useAppSelector((state) => state.modal)

  const openModal = (type: App.ModalTypes) => {
    appDispatch(changeModalState(true, type))
  }

  const closeModal = () => {
    appDispatch(changeModalState(false))
  }

  return {
    isOpen: state,
    type,
    metadata: metadata as T,
    openModal,
    closeModal
  }
}
